// Extrai DDD + número para o preview (espelha a regra do backend/legado).
export const parsearCelular = celular => {
  const digitos = (celular || '').replace(/\D/g, '');
  if (digitos.length !== 10 && digitos.length !== 11) return null;
  const ddd = digitos.slice(0, 2);
  const resto = digitos.slice(2);
  const numero =
    resto.length === 9
      ? `${resto.slice(0, 5)}-${resto.slice(5)}`
      : `${resto.slice(0, 4)}-${resto.slice(4)}`;
  return { ddd, numero };
};

// Endpoints de imagem usam responseType 'blob'; quando dão erro, o interceptor rejeita
// com o corpo (Blob). Demais endpoints rejeitam com objeto { mensagem }.
export const extrairMensagemErro = async err => {
  try {
    if (err instanceof Blob) {
      const texto = await err.text();
      try {
        const obj = JSON.parse(texto);
        return obj.mensagem || obj.message || texto || 'Erro inesperado';
      } catch (e) {
        return texto || 'Erro inesperado';
      }
    }
  } catch (e) {
    return 'Erro inesperado';
  }
  if (err && err.mensagem) return err.mensagem;
  if (err && err.message) return err.message;
  return 'Erro inesperado';
};
